import CenterBox from './CenterBox'

export default CenterBox
